import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMessage(e) {
  // No HTTP response at all = network/proxy problem, not an app error.
  if (!e?.response) {
    return "We couldn't reach the server. Please check your connection and try again.";
  }
  return (
    formatApiErrorDetail(e.response.data?.detail) ||
    `Request failed (${e.response.status}). Please try again.`
  );
}
